import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToReservations = () => {
    const element = document.getElementById('reservations');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_rose-bistro/artifacts/g1gsfe88_terrasse%20lvr.jpg)',
          filter: 'brightness(0.6)'
        }} />

      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1
          className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6"
          style={{ fontFamily: "'Crimson Text', serif" }}>

          La Vie en Rose
        </h1>
        <p className="md:text-2xl !font-light !text-xl mb-8">Experimenta el arte de la gastronomía francesa

        </p>
        <p className="md:text-xl max-w-2xl !text-lg mb-12 mx-auto opacity-90">Auténtica cocina francesa elaborada con pasión, elegancia y los mejores ingredientes.

        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={scrollToReservations}
            className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 hover:bg-gray-900 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg !font-medium !text-lg gap-2 px-8 py-6 rounded-md shadow text-white bg-black">Reserva ahora


          </Button>
          <Button
            onClick={scrollToMenu}
            variant="outline"
            className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 border-2 border-white hover:bg-white hover:text-black transition-all duration-200 hover:-translate-y-1 !font-medium !text-lg gap-2 px-8 py-6 rounded-md shadow-sm text-white bg-transparent">Nuestro Menu


          </Button>
        </div>
      </div>
    </section>);

};

export default Hero;